// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__GroupSummary__buttonsright{margin-left:auto}.app__GroupSummary__buttonsgap{margin-right:3px}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/twia-capability-agencyadmin-react/components/GroupSummary/GroupSummary.module.scss"],"names":[],"mappings":"AAAA,iCACI,gBAAA,CAGJ,+BACI,gBAAA","sourcesContent":[".buttonsright{\r\n    margin-left: auto;\r\n}\r\n\r\n.buttonsgap{\r\n    margin-right: 3px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonsright": "app__GroupSummary__buttonsright",
	"buttonsgap": "app__GroupSummary__buttonsgap"
};
export default ___CSS_LOADER_EXPORT___;
